<template>
  <div class="toggle-with-title-container">
    <div class="main-title-container">
      {{ title }}
    </div>
    <toggle :active="value"
            @changeValue="item => this.$emit('changeValue', item)"
            :name-check="`toggle-with-title-container-${id}`"/>
  </div>
</template>

<script>
import Toggle from "@/components/shared/toggle/Toggle.vue";

export default {
  name: "ToggleWithTitle",
  components: {Toggle},
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
    },
    value: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
.toggle-with-title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 24px;

  .main-title-container {
    font-size: 18px;
    font-weight: 700;
    color: var(--color-purple);
  }
}
</style>